import { useGlobalState } from "../hooks/useGlobalState";
import { useState } from "react";
import { Components, useTh } from "leva/plugin";
import { StyledIcons } from "../styles/StyledIcons";
import { useNotifications } from "../context/NotificationProvider";
import SettingsSVG from "./SettingsSVG";
import PlusSVG from "./PlusSVG";
import HoverMenuButton from "./HoverMenuButton";
import {
	BounceMenuItem,
	DistributionMenuItem,
	EasingMenuItem,
	ElasticMenuItem,
	MenuItemButton,
} from "./MenuItem";
import IconEasing from "./icons/IconEasing";
import IconDistribution from "./icons/IconDistribution";
import IconBounce from "./icons/IconBounce";
import IconElastic from "./icons/IconElastic";
import HorizontalScroll from "./HorizontalScroll";
const { Row } = Components;

const TopSection = ({
	setSavePopup,
}: {
	setSavePopup?: (arg: boolean) => void;
}) => {
	const { dispatch, UIStatus } = useGlobalState();
	const { addNotification } = useNotifications();
	const fillColor = useTh("colors", "highlight1");
	const [isModalVisible, setIsModalVisible] = useState(false);

	const handleToggleSavePopup = () => {
		if (setSavePopup) setSavePopup(true);
		else {
			// alert("Please change view to Easing or Distribute to save presets.")
			addNotification({
				title: "Can't add preset",
				message: "Please change view to Easing or Distribute to save presets.",
				type: "error",
			});
		}
	};

	function handleDistributeToggle(): void {
		if (UIStatus.currentDisplay !== "distribute") {
			dispatch({
				type: "UIStatusUpdate",
				payload: {
					id: Date.now(),
					currentDisplay: "distribute",
					initializationTime: Date.now(),
				},
			});
		}
	}

	function handleBezierToggle(): void {
		if (UIStatus.currentDisplay !== "bezier") {
			dispatch({
				type: "UIStatusUpdate",
				payload: {
					id: Date.now(),
					currentDisplay: "bezier",
					initializationTime: Date.now(),
				},
			});
		}
	}

	function handleBounceToggle(): void {
		if (UIStatus.currentDisplay !== "bounce") {
			dispatch({
				type: "UIStatusUpdate",
				payload: {
					id: Date.now(),
					currentDisplay: "bounce",
					initializationTime: Date.now(),
				},
			});
		}
	}

	function handleElasticToggle(): void {
		if (UIStatus.currentDisplay !== "elastic") {
			dispatch({
				type: "UIStatusUpdate",
				payload: {
					id: Date.now(),
					currentDisplay: "elastic",
					initializationTime: Date.now(),
				},
			});
		}
	}

	return (
		<div className="flex z-50 w-full items-center pb-1">
			{/* <HoverMenuButton
					onClick={() => console.log("clicked")}
					label={capitalizeFirstLetter(
						UIStatus.currentDisplay === "bezier"
							? "easing"
							: UIStatus.currentDisplay
					)}
					setIsModalVisible={setIsModalVisible}
					isModalVisible={isModalVisible}
					// staticOn={true}
				>
					<EasingMenuItem
						index={0}
						onClick={handleBezierToggle}
						currentDisplay={UIStatus.currentDisplay}
						visible={isModalVisible}
					/>
					<DistributionMenuItem
						index={1}
						onClick={handleDistributeToggle}
						currentDisplay={UIStatus.currentDisplay}
						visible={isModalVisible}
					/>
					<BounceMenuItem
						index={2}
						onClick={handleBounceToggle}
						currentDisplay={UIStatus.currentDisplay}
						visible={isModalVisible}
					/>
					<ElasticMenuItem
						index={3}
						onClick={handleElasticToggle}
						currentDisplay={UIStatus.currentDisplay}
						visible={isModalVisible}
					/>
				</HoverMenuButton> */}

			<HorizontalScroll>
				<div className="flex py-1">
					<MenuItemButton
						onClick={handleBezierToggle}
						label="bezier"
						currentDisplay={UIStatus.currentDisplay}
						icon={<IconEasing />}
					/>
					<MenuItemButton
						onClick={handleDistributeToggle}
						label="distribute"
						currentDisplay={UIStatus.currentDisplay}
						icon={<IconDistribution />}
					/>
					<MenuItemButton
						onClick={handleBounceToggle}
						label="bounce"
						currentDisplay={UIStatus.currentDisplay}
						icon={<IconBounce />}
					/>
					<MenuItemButton
						onClick={handleElasticToggle}
						label="elastic"
						currentDisplay={UIStatus.currentDisplay}
						icon={<IconElastic />}
					/>
					{/* <button onClick={handleOpenPresets} className="flex items-center">
						Presets
					</button> */}
				</div>
			</HorizontalScroll>
			<div className="flex ml-auto">
				<StyledIcons onClick={handleToggleSavePopup}>
					<PlusSVG fill={fillColor} />
				</StyledIcons>
				<StyledIcons
					onClick={() =>
						dispatch({
							type: "UIStatusUpdate",
							payload: {
								id: Date.now(),
								currentDisplay: "config",
								initializationTime: Date.now(),
							},
						})
					}
				>
					<SettingsSVG fill={fillColor} />
				</StyledIcons>
			</div>
		</div>
	);
};

export default TopSection;
